import React, {
  createRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
// @ts-ignore
import ReactFileViewer from 'react-file-viewer';
import { useHistory, useParams } from 'react-router';
import moment from 'moment';
import * as Yup from 'yup';
import ReactSelect from 'react-select';

import {
  Button,
  Divider,
  Link,
  makeStyles,
  Paper,
  Theme,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormLabel,
  colors,
  Tooltip,
} from '@material-ui/core';

import { ListItemIcon, Menu, MenuItem, TextField } from '@mui/material';

import {
  Timeline,
  TimelineItem,
  TimelineConnector,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineDot,
  TimelineContent,
} from '@material-ui/lab';

import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';

import AdapterDateFns from '@mui/lab/AdapterDateFns';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import {
  AddCircle,
  ArrowBack,
  Check,
  Delete,
  Description,
  Edit,
  GetApp,
  Print,
} from '@material-ui/icons';
import { useKeycloak } from '@react-keycloak/web';
import { CreateNoteData, CreateProgressData, UpdateProgressData } from './dto';
import Input from '../../../components/Input';
import Loader from '../../../components/Loader';
import ExpirationWarning from '../../../components/ExpirationWarning';
import EmptyProgress from '../../../components/EmptyProgress';
import Snackbar, { AlertComponentProps } from '../../../components/Snackbar';

import { Record } from '../../../models/record';
import { Progress, ProgressFile } from '../../../models/progress';
import { useAxios } from '../../../utils/hooks';
import { getFileChip, getChip } from '../../../utils/getChip';
import { progressTypeIcons } from '../../../utils/getProgressIcon';
import getValidationErrors from '../../../utils/getValidationErrors';
import Select from '../../../components/Select';
import { SelectProps } from '../List/dto';
import FileUploader, { File } from '../../../components/FileUploader';
import { User } from '../../../models/user';
import { Note } from '../../../models/note';
import { RealmRoles } from '../../../routes';

const useStyles = makeStyles((theme: Theme) => ({
  timelineContainer: {
    background: theme.palette.background.paper,
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
  },
  timeline: {
    marginBottom: theme.spacing(10),
  },
  title: {
    textTransform: 'uppercase',
    color: theme.palette.secondary.light,
    fontSize: '0.9rem',
  },
  formTitles: {
    fontWeight: 'bolder',
  },
  paper: {
    padding: theme.spacing(2),
    // height: '200px',
  },
  button: {
    marginRight: theme.spacing(1),
    '&:last-child': {
      marginRight: 0,
    },
  },
  editButton: {
    width: '10px',
    padding: theme.spacing(0.5, 0),
    marginLeft: theme.spacing(1),
  },
  noteButton: {
    margin: 2,
    width: 'fit-content',
  },
  notes: {
    padding: theme.spacing(1),
    background: '#FFFACD',
    fontSize: '0.8rem',
  },
  content: {
    padding: theme.spacing(2, 1),
    minWidth: '80%',
  },
  opposite: {
    maxWidth: '20%',
  },
  secondaryTail: {
    backgroundColor: theme.palette.primary.main,
  },
  filter: {
    background: theme.palette.background.paper,
    padding: theme.spacing(4, 2),
  },
  filterHeader: {
    background: theme.palette.background.default,
    padding: theme.spacing(1),
  },
  item: {
    paddingRight: '4%',
  },
  titleGrid: {
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    borderTopRightRadius: '10px',
    borderTopLeftRadius: '10px',
  },
  chiplink: {
    textDecoration: 'none',
  },
}));

interface IRecordProps {
  notes: boolean;
}

interface KeyAndValueString {
  [key: string]: string;
}

const FormTypeToUrl: KeyAndValueString = {
  review: 'avaliacao',
  declaration: 'declaracao',
  socialService: 'encaminhamento-servico-social',
  parents: 'encaminhamento-atendimento-pais',
  forwarding: 'encaminhamento-terapeuta',
  foodForward: 'encaminhamento-transtornos-alimentares',
  groupForward: 'encaminhamento-setor-grupos',
  clinicForward: 'encaminhamento-corpo-clinico',
  consultantRequest: 'consultoria-transtornos-alimentares',
  psychopedagogy: 'encaminhamento-psicopedagogia',
  discount: 'reducao-valor',
  diagnosis: 'psicodiagnostico',
  psychiatric: 'avaliacao-psiquiatrica',
  quarterplan: 'revisao-semestral-plano',
  init: 'inicial',
  update: 'atualizacao-cadastral',
  adoption: 'inicial-adocao',
  parentInit: 'inicial-responsaveis',
  closure: 'encerramento-atendimento',
  screening: 'parecer-triagem',
  babyScreening: 'parecer-triagem-intervencoes-precoces',
  monthlyEvolution: 'evolucao-mensal-ambientoterapia',
  hosting: 'acolhimento',
  monthlyNutritionEvolution: 'evolucao-mensal-nutricao',
  psychiatryEvolution: 'evolucao-psiquiatrica',
};

const TypeToTitle: KeyAndValueString = {
  review: 'Avaliação',
  declaration: 'Declaração',
  socialService: 'Encaminhamento para o Serviço Social',
  parents: 'Encaminhamento Atendimento a Pais',
  forwarding: 'Encaminhamento Terapeuta',
  foodForward: 'Encaminhamento Transtornos Alimentares',
  groupForward: 'Encaminhamento Setor de Grupos',
  clinicForward: 'Encaminhamento Corpo Clínico',
  consultantRequest: 'Solicitação Consultoria Transtornos Alimentares',
  psychopedagogy: 'Encaminhamento para Psicopedagogia',
  discount: 'Pedido para Redução do Valor',
  diagnosis: 'Psicodiagnóstico',
  psychiatric: 'Avaliação Psiquiátrica',
  quarterplan: 'Revisão Semestral do Plano de Tratamento',
  init: 'Ficha Inicial',
  adoption: 'Ficha de Contato Inicial do MP',
  update: 'Ficha de Atualização Cadastral',
  parentInit: 'Ficha Inicial a Pais e/ou Responsáveis',
  closure: 'Nota de Encerramento do Atendimento',
  screening: 'Parecer da Equipe de Triagem',
  babyScreening: 'Parecer da Equipe de Triagem de Pais Bebês',
  monthlyEvolution: 'Evolução Mensal do Paciente em Ambientoterapia',
  hosting: 'Acolhimento',
  monthlyNutritionEvolution: 'Evolução Mensal da Nutrição',
  psychiatryEvolution: 'Evolução Psiquiátrica do Paciente',
};

const ShowRecord: React.FC<IRecordProps> = ({ notes = true }) => {
  const api = useAxios();
  const history = useHistory();
  const { keycloak } = useKeycloak();
  const classes = useStyles();
  const pathLink = createRef();
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [initialFiles, setInitialFiles] = useState<File[]>([]);
  const [professionalIds, setProfessionalIds] = useState<string[]>([]);
  const [coordIds, setCoordIds] = useState<string[]>([]);
  const [linkOpen, setLinkOpen] = useState(false);
  const [link, setLink] = useState('');
  const [openProgress, setOpenProgress] = useState(false);
  const [openEditProgress, setOpenEditProgress] = useState(false);
  const [openNote, setOpenNote] = useState(false);
  const [openEditNote, setOpenEditNote] = useState(false);
  const [progressId, setProgressId] = useState<string | null>(null);
  const formRef = useRef<FormHandles>(null);
  const formEditRef = useRef<FormHandles>(null);
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [fileLoading, setFileLoading] = useState(false);
  const [fileData, setFileData] = useState<any>(false);
  const [fileError, setFileError] = useState(false);
  const [record, setRecord] = useState<Record | null>(null);
  const [progress, setProgress] = useState<Progress[]>([]);
  const [editProgress, setEditProgress] = useState<Progress>({} as Progress);
  const [editNote, setEditNote] = useState<Note>({} as Note);
  const [users, setUsers] = useState<SelectProps[]>([]);
  const formFilterRef = useRef<FormHandles>(null);
  const [date, setDate] = useState<Date | null>(null);
  const [authors, setAuthors] = useState<SelectProps[]>([]);
  const [filters, setFilters] = useState('');
  const [filterTypes, setFilterTypes] = useState({
    type: '',
    author_id: '',
    date: '',
  });

  const [alert, setAlert] = useState<
    AlertComponentProps & { isActive: boolean }
  >({
    isActive: false,
    type: 'info',
    message: 'none',
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    async function getRecordData() {
      try {
        const recordResponse = await api.current?.get(`/records/${id}`);
        setRecord(recordResponse?.data);

        const progressResponse = await api.current?.get(
          `/records/${id}/progress?${filters}`,
        );

        setProgress(progressResponse?.data);

        const usersResponse = await api.current?.get(`/users`);

        setUsers(
          usersResponse?.data
            .map((user: User) => ({
              ...user,
              lastName: `${user.lastName} ${
                user.attributes && user.attributes.aluno ? '(aluno)' : ''
              }`,
            }))
            .map((user: User) => ({
              value: user.id,
              label: `${user.firstName} ${user.lastName}`,
            })),
        );

        setCoordIds(
          usersResponse?.data
            .filter(
              (user: User) =>
                user.attributes &&
                user.attributes.coordenador &&
                user.attributes.coordenador[0] === 'true',
            )
            .map((user: User) => user.id),
        );
        setProfessionalIds(
          usersResponse?.data
            .filter(
              (user: User) => !user.attributes || !user.attributes.coordenador,
            )
            .map((user: User) => user.id),
        );

        const currentAuthors = progressResponse?.data.map(
          (progressItem: Progress) => {
            return {
              value: progressItem.author_id,
              label: progressItem.author,
            };
          },
        );

        const result = currentAuthors.filter(
          (value: any, index: any, self: any) =>
            self.findIndex((m: any) => m.value === value.value) === index,
        );

        setAuthors(result);
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao carregar prontuário.',
        });
      } finally {
        setLoading(false);
      }
    }

    getRecordData();
  }, [api, id, filters]);

  const resetAlert = () => {
    setAlert({
      isActive: false,
      type: 'info',
      message: 'none',
    });
  };

  const handleLinkClose = () => {
    setLinkOpen(false);
    setLink('');
  };

  const handleClickPrint = useCallback(async () => {
    resetAlert();
    setLoading(true);
    setLink('--');

    try {
      const linkResponse = await api.current?.get(`/records/${id}/print`);

      if (linkResponse?.data && linkResponse?.data.link) {
        setLink(linkResponse?.data.link);
      } else {
        throw new Error();
      }

      setAlert({
        isActive: true,
        type: 'success',
        message: 'Link para impressão gerado com sucesso.',
      });
    } catch (error) {
      setAlert({
        isActive: true,
        type: 'error',
        message: 'Erro ao gerar link para impressão.',
      });
    } finally {
      setLinkOpen(true);
      setLoading(false);
    }
  }, [api, id]);

  const handleClickReopen = useCallback(async () => {
    resetAlert();
    setLoading(true);

    try {
      await api.current?.patch(`/records/${id}/reopen`);

      const currentRecord = record;
      (currentRecord as Record).status = 'active';
      setRecord(currentRecord);

      const newProgress = await api.current?.get(`/records/${id}/progress`);

      setProgress(newProgress?.data);

      setAlert({
        isActive: true,
        type: 'success',
        message: 'Prontuário reaberto com sucesso.',
      });
    } catch (error) {
      setAlert({
        isActive: true,
        type: 'error',
        message: 'Erro ao reabrir prontuário.',
      });
    } finally {
      setLoading(false);
    }
  }, [api, id, record]);

  const handleFile = useCallback(
    (fileId: string) => {
      setFileIds([...fileIds, fileId]);
    },
    [fileIds],
  );

  const handleOpenProgress = () => {
    setOpenProgress(true);
  };

  const handleOpenEditProgress = (progress: Progress) => {
    setEditProgress(progress);
    setFileIds(progress.files.map((file) => file._id));
    setInitialFiles(
      progress.files
        .filter((file) => file)
        .map(
          (file: ProgressFile) =>
            ({
              name: file.originalname || 'Arquivo não encontrado',
              size: file.size || 0,
              type: file.mimetype || 'xyz',
            } as File),
        ),
    );
    setOpenEditProgress(true);
  };

  const handleCloseEditProgress = () => {
    setOpenEditProgress(false);
  };

  const handleCloseProgress = () => {
    setOpenProgress(false);
  };

  const handleCloseFile = (fileBlob: any) => {
    URL.revokeObjectURL(fileBlob);

    setFileData(false);
    setFileError(false);
  };

  const handleOpenNote = (progress: Progress) => {
    setEditProgress(progress);
    setOpenNote(true);
  };

  const handleCloseNote = () => {
    setProgressId(null);
    setOpenNote(false);
  };

  const handleOpenEditNote = (note: Note) => {
    setEditNote(note);
    setFileIds(note.files.map((file) => file._id));
    setInitialFiles(
      note.files
        .filter((file) => file)
        .map(
          (file: ProgressFile) =>
            ({
              name: file.originalname,
              size: file.size,
              type: file.mimetype,
            } as File),
        ),
    );
    setOpenEditNote(true);
  };

  const handleCloseEditNote = () => {
    setOpenEditNote(false);
  };

  const handleSubmitProgress = useCallback(
    async (data: CreateProgressData) => {
      try {
        resetAlert();
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          content: Yup.string().required('Insira uma evolução'),
        });

        await schema.validate(data, { abortEarly: false });
        data.type = 'evolution';
        data.title = 'Evolução';
        data.files = fileIds;

        const newProgress = await api.current?.post(
          `/records/${id}/progress`,
          data,
        );

        const getNewProgress = await api.current?.get(
          `/records/${id}/progress/${newProgress?.data._id}`,
        );

        setProgress([getNewProgress?.data, ...progress]);
        setFileIds([]);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Evolução criada com sucesso.',
        });
        handleCloseProgress();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao criar evolução.',
          });
        }
      }
    },
    [id, progress, api, fileIds],
  );

  const handleSubmitEditProgress = useCallback(
    async (data: UpdateProgressData) => {
      try {
        resetAlert();
        formEditRef.current?.setErrors({});

        const schema = Yup.object().shape({
          content: Yup.string().required('Insira uma evolução'),
        });

        await schema.validate(data, { abortEarly: false });

        data.files = fileIds;
        // data.forms = data.forms.map(form => form.id)

        await api.current?.patch(
          `/records/${id}/progress/${editProgress._id}`,
          data,
        );

        const getNewProgress = await api.current?.get(
          `/records/${id}/progress/${editProgress._id}`,
        );

        const currentProgress = progress;
        const progressIdx = currentProgress.findIndex(
          (progress) => progress._id === editProgress._id,
        );
        currentProgress[progressIdx] = getNewProgress?.data;

        setProgress(currentProgress);
        setFileIds([]);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Evolução atualizada com sucesso.',
        });
        handleCloseEditProgress();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formEditRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao atualizar evolução.',
          });
        }
      }
    },
    [id, progress, api, fileIds, editProgress],
  );

  const handleSubmitApproveProgress = useCallback(
    async (progressId: string) => {
      setLoading(true);
      try {
        await api.current?.get(`/records/${id}/progress/${progressId}/approve`);

        const approvedProgress = await api.current?.get(
          `/records/${id}/progress/${progressId}`,
        );

        const record = await api.current?.get(`/records/${id}`);

        setRecord(record?.data);

        const currentProgress = progress;
        const progressIdx = currentProgress.findIndex(
          (progress) => progress._id === progressId,
        );
        currentProgress[progressIdx] = approvedProgress?.data;

        setProgress(currentProgress);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Evolução aprovada com sucesso.',
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formEditRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao aprovar evolução.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [id, progress, api],
  );

  const handleSubmitDeleteProgress = useCallback(
    async (progressId: string) => {
      setLoading(true);
      try {
        await api.current?.delete(`/records/${id}/progress/${progressId}`);

        const currentProgress = progress.filter((p) => p._id !== progressId);

        setProgress(currentProgress);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Evolução deletada com sucesso.',
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formEditRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao deletar evolução.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [id, progress, api],
  );

  const handleSubmitApproveNote = useCallback(
    async (note: Note) => {
      setLoading(true);
      try {
        await api.current?.get(
          `/records/${id}/progress/${note.progress}/notes/${note._id}/approve`,
        );

        const updatedProgressLit = await api.current?.get(
          `/records/${id}/progress`,
        );

        setProgress(updatedProgressLit?.data);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Nota aprovada com sucesso.',
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formEditRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao aprovar nota.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [id, api],
  );

  const handleSubmitNote = useCallback(
    async (data: CreateNoteData) => {
      try {
        resetAlert();
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          content: Yup.string().required('Insira uma nota'),
        });

        await schema.validate(data, { abortEarly: false });
        data.title = 'Nota do Supervisor';
        data.files = fileIds;
        data.destination_id = editProgress.author_id;

        await api.current?.post(
          `/records/${id}/progress/${editProgress._id}/notes`,
          data,
        );

        const updatedProgressLit = await api.current?.get(
          `/records/${id}/progress`,
        );

        setFileIds([]);
        setProgress(updatedProgressLit?.data);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Nota criada com sucesso.',
        });
        handleCloseNote();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao criar nota.',
          });
        }
      }
    },
    [id, api, editProgress, fileIds],
  );

  const handleSubmitEditNote = useCallback(
    async (data: CreateNoteData) => {
      try {
        setLoading(true);
        resetAlert();
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          content: Yup.string().required('Insira uma nota'),
        });

        await schema.validate(data, { abortEarly: false });
        data.title = 'Nota do Supervisor';
        data.files = fileIds;

        await api.current?.patch(
          `/records/${id}/progress/${editNote.progress}/notes/${editNote._id}`,
          data,
        );

        const updatedProgressLit = await api.current?.get(
          `/records/${id}/progress`,
        );

        setFileIds([]);
        setProgress(updatedProgressLit?.data);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Nota atualizada com sucesso.',
        });
        handleCloseEditNote();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formEditRef.current?.setErrors(errors);
        } else {
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao atualizar nota.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [id, api, fileIds, editNote],
  );

  const handleFilters = useCallback(
    (type: string, data: any) => {
      setLoading(true);

      switch (type) {
        case 'type':
          setFilterTypes({
            ...filterTypes,
            type: data && data.value ? `&type=${data.value}` : '',
          });
          break;
        case 'author':
          setFilterTypes({
            ...filterTypes,
            author_id: data && data.value ? `&author_id=${data.value}` : '',
          });
          break;
        case 'date':
          setFilterTypes({
            ...filterTypes,
            date: data ? `&date=${moment(data).format('YYYY-MM-DD')}` : '',
          });
          break;
        default:
          break;
      }
    },
    [filterTypes],
  );

  const handleProfessionalSelect = useCallback(
    async (list: any) => {
      resetAlert();
      try {
        let operation = '';
        const recordCoords = users.filter(
          (user) =>
            coordIds.includes(user.value) &&
            record?.professional_id.includes(user.value),
        );

        const totalLength = list.length + recordCoords.length;

        if (record) {
          if (totalLength > record?.professional_id.length) {
            operation = 'adicionado';

            const allProsIds = [...list, ...recordCoords].map(
              (pro) => pro.value,
            );

            const proIdToAdd = allProsIds.filter(
              (id) => !record?.professional_id.includes(id),
            )[0];

            await api.current?.patch(
              `/records/${id}/professional/${proIdToAdd}/add`,
            );

            const currentRecord = record;
            currentRecord?.professional_id.push(proIdToAdd);
            setRecord(currentRecord);
          } else {
            operation = 'removido';

            const allProsIds = [...list, ...recordCoords].map(
              (pro) => pro.value,
            );

            const proIdToRemove = record?.professional_id.filter(
              (id) => !allProsIds.includes(id),
            )[0];

            await api.current?.patch(
              `/records/${id}/professional/${proIdToRemove}/remove`,
            );

            const currentRecord = record;
            const newProsList = record?.professional_id.filter(
              (id) => id !== proIdToRemove,
            );
            currentRecord.professional_id = newProsList;
            setRecord(currentRecord);
          }
        }

        setAlert({
          isActive: true,
          type: 'success',
          message: `Terapeuta ${operation} com sucesso.`,
        });
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao adicionar/remover terapeuta.',
        });
      }
    },
    [api, id, coordIds, record, users],
  );

  const handleCoordSelect = useCallback(
    async (list: any) => {
      resetAlert();
      try {
        let operation = '';
        const recordPros = users.filter(
          (user) =>
            professionalIds.includes(user.value) &&
            record?.professional_id.includes(user.value),
        );

        const totalLength = list.length + recordPros.length;

        if (record) {
          if (totalLength > record?.professional_id.length) {
            operation = 'adicionado';

            const allProsIds = [...list, ...recordPros].map((pro) => pro.value);

            const coordIdToAdd = allProsIds.filter(
              (id) => !record?.professional_id.includes(id),
            )[0];

            await api.current?.patch(
              `/records/${id}/professional/${coordIdToAdd}/add`,
            );

            const currentRecord = record;
            currentRecord?.professional_id.push(coordIdToAdd);
            setRecord(currentRecord);
          } else {
            operation = 'removido';

            const allProsIds = [...list, ...recordPros].map((pro) => pro.value);

            const coordIdToRemove = record?.professional_id.filter(
              (id) => !allProsIds.includes(id),
            )[0];

            await api.current?.patch(
              `/records/${id}/professional/${coordIdToRemove}/remove`,
            );

            const currentRecord = record;
            const newProsList = record?.professional_id.filter(
              (id) => id !== coordIdToRemove,
            );
            currentRecord.professional_id = newProsList;
            setRecord(currentRecord);
          }
        }

        setAlert({
          isActive: true,
          type: 'success',
          message: `Setor ${operation} com sucesso.`,
        });
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao adicionar/remover setor.',
        });
      }
    },
    [api, id, professionalIds, record, users],
  );

  const handleSupervisorSelect = useCallback(
    async (list: any) => {
      resetAlert();
      try {
        await api.current?.patch(`/records/${id}`, {
          supervisor_id: list.map((item: SelectProps) => item.value),
          supervisor: list.map((item: SelectProps) => item.label),
        });

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Prontuário atualizado com sucesso.',
        });
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao atualizar prontuário.',
        });
      }
    },
    [api, id],
  );

  const handleDownload = useCallback(
    (path: string) => {
      resetAlert();
      setFileError(false);
      setFileLoading(true);
      const formatPath = path.split('/');
      const filePath = formatPath.slice(0, -1);
      const fileName = formatPath[formatPath.length - 1];
      const extension = (fileName.split('.').pop() || '').toLowerCase();
      let fileType = extension;

      // Arquivos .doc legados (binários) e .docx são renderizados pela mesma
      // engine (mammoth). Tentamos como "docx"; se o conteúdo for um .doc
      // binário real, o onError do visualizador exibe o fallback de download.
      if (extension === 'doc') {
        fileType = 'docx';
      }

      api.current
        ?.get(`files/${filePath.join('*')}*${fileName}`, {
          responseType: 'blob',
        })
        .then((response: any) => {
          const fileData = {
            blob: URL.createObjectURL(response.data),
            fileType,
            fileName,
          };

          setFileData(fileData);
        })
        .catch(() =>
          setAlert({
            isActive: true,
            type: 'error',
            message: 'Erro ao exibir arquivo.',
          }),
        )
        .finally(() => setFileLoading(false));
    },
    [api],
  );

  useEffect(() => {
    setFilters(filterTypes.type + filterTypes.author_id + filterTypes.date);
  }, [filterTypes]);

  return (
    <div>
      <Loader loading={loading} />
      <Loader loading={fileLoading} />

      {progress.length >= 1 &&
        moment().diff(progress[0].updatedAt, 'months') >= 2 &&
        record?.status === 'active' && <ExpirationWarning />}
      <Dialog
        open={openProgress}
        onClose={handleCloseProgress}
        aria-labelledby="form-dialog-title"
      >
        <Form ref={formRef} onSubmit={handleSubmitProgress}>
          <DialogTitle id="form-dialog-title">Criar Evolução</DialogTitle>

          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Insira os dados da evolução do paciente
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  isMultiline
                  rows={5}
                  id="content"
                  label="Evolução"
                  name="content"
                />
              </Grid>

              <Grid item xs={12}>
                <FileUploader handleFileId={handleFile} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseProgress} color="default">
              Cancelar
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      <Dialog
        open={openEditProgress}
        onClose={handleCloseEditProgress}
        aria-labelledby="form-dialog-title"
      >
        <Form
          ref={formEditRef}
          initialData={editProgress}
          onSubmit={handleSubmitEditProgress}
        >
          <DialogTitle id="form-dialog-title">Editar Evolução</DialogTitle>

          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Insira os dados da evolução do paciente
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  isMultiline
                  rows={5}
                  id="content"
                  label="Evolução"
                  name="content"
                />
              </Grid>

              <Grid item xs={12}>
                <FileUploader
                  handleFileId={handleFile}
                  initialFiles={initialFiles}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEditProgress} color="default">
              Cancelar
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      <Dialog
        open={openNote}
        onClose={handleCloseNote}
        aria-labelledby="form-dialog-title"
      >
        <Form ref={formRef} onSubmit={handleSubmitNote}>
          <DialogTitle id="form-dialog-title">Criar Nota</DialogTitle>

          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={8} />

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Insira uma nota sobre a evolução do paciente
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  isMultiline
                  rows={5}
                  id="content"
                  label="Nota"
                  name="content"
                />
              </Grid>

              <Grid item xs={12}>
                <FileUploader handleFileId={handleFile} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNote} color="default">
              Cancelar
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      <Dialog
        open={openEditNote}
        onClose={handleCloseEditNote}
        aria-labelledby="form-dialog-title"
      >
        <Form
          ref={formEditRef}
          initialData={editNote}
          onSubmit={handleSubmitEditNote}
        >
          <DialogTitle id="form-dialog-title">Editar Nota</DialogTitle>

          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={8} />

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Insira uma nota sobre a evolução do paciente
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  isMultiline
                  rows={5}
                  id="content"
                  label="Nota"
                  name="content"
                />
              </Grid>

              <Grid item xs={12}>
                <FileUploader
                  handleFileId={handleFile}
                  initialFiles={initialFiles}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEditNote} color="default">
              Cancelar
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      <Dialog
        open={linkOpen}
        onClose={handleLinkClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Link para impressão</DialogTitle>

        <DialogContent>
          <Link href={link} target="blank">
            {link}
          </Link>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleLinkClose}>Fechar</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={fileData}
        onClose={() => handleCloseFile(fileData.blob)}
        fullWidth
        maxWidth="md"
      >
        <DialogContent
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            {fileError ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: 'center',
                  gap: '16px',
                }}
              >
                <Description color="primary" style={{ fontSize: 72 }} />
                <Typography>
                  Não foi possível pré-visualizar este arquivo. Faça o download
                  para abri-lo no seu computador.
                </Typography>
                <Button
                  component="a"
                  href={fileData.blob}
                  download={fileData.fileName}
                  color="primary"
                  variant="contained"
                  startIcon={<GetApp />}
                >
                  Baixar arquivo
                </Button>
              </div>
            ) : (
              <ReactFileViewer
                fileType={fileData.fileType}
                filePath={fileData.blob}
                onError={() => setFileError(true)}
              />
            )}
          </div>

          {/* <iframe
            title="file"
            src={fileData.blob}
            style={{ width: '100%', height: '500px' }}
          /> */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleCloseFile(fileData.blob)}
            color="primary"
            variant="contained"
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.titleGrid}
      >
        <div>
          <h2 className={classes.title}>{`Prontuário: ${record?.number}`}</h2>
          {getChip(record?.status || '')}
        </div>

        <div>
          <Button
            className={classes.button}
            variant="outlined"
            color="primary"
            startIcon={<ArrowBack />}
            onClick={() => history.goBack()}
          >
            Voltar
          </Button>

          {record?.status === 'closed' && (
            <Button
              id="basic-button"
              aria-controls="basic-menu"
              aria-haspopup="true"
              variant="contained"
              className={classes.button}
              startIcon={<AddCircle />}
              onClick={() => handleClickReopen()}
              aria-expanded={open ? 'true' : undefined}
              style={{ background: colors.green[700], color: 'white' }}
            >
              Reabrir
            </Button>
          )}

          <Tooltip title="Temporariamente Indisponível">
            <span className={classes.button}>
              <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                variant="contained"
                color="primary"
                className={classes.button}
                // disabled={
                //   record?.status !== 'active' ||
                //   record?.supervisor_id?.includes(keycloak?.subject as string)
                // }
                disabled
                aria-expanded={open ? 'true' : undefined}
                startIcon={<Print />}
                onClick={() => handleClickPrint()}
              >
                Imprimir
              </Button>
            </span>
          </Tooltip>

          <Button
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            variant="contained"
            color="primary"
            className={classes.button}
            disabled={
              record?.status !== 'active' ||
              record?.supervisor_id?.includes(keycloak?.subject as string)
            }
            aria-expanded={open ? 'true' : undefined}
            startIcon={<AddCircle />}
            onClick={handleMenu}
          >
            Adicionar Ficha
          </Button>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/avaliacao`)}
            >
              <ListItemIcon>{progressTypeIcons.review}</ListItemIcon>
              <Typography variant="inherit">Ficha de Avaliação</Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/parecer-triagem`)}
            >
              <ListItemIcon>{progressTypeIcons.screening}</ListItemIcon>
              <Typography variant="inherit">
                Parecer da Equipe de Triagem
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/parecer-triagem-intervencoes-precoces`)}
            >
              <ListItemIcon>{progressTypeIcons.babyScreening}</ListItemIcon>
              <Typography variant="inherit">
                Parecer da Equipe de Triagem de Pais Bebês
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/acolhimento`)}
            >
              <ListItemIcon>{progressTypeIcons.hosting}</ListItemIcon>
              <Typography variant="inherit">Acolhimento</Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/declaracao`)}
            >
              <ListItemIcon>{progressTypeIcons.declaration}</ListItemIcon>
              <Typography variant="inherit">Declaração CEAPIA</Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/encaminhamento-servico-social`)}
            >
              <ListItemIcon>{progressTypeIcons.socialService}</ListItemIcon>
              <Typography variant="inherit">
                Encaminhamento Serviço Social
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/encaminhamento-corpo-clinico`)}
            >
              <ListItemIcon>{progressTypeIcons.clinicForward}</ListItemIcon>
              <Typography variant="inherit">
                Encaminhamento Corpo Clínico
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/consultoria-transtornos-alimentares`)}
            >
              <ListItemIcon>{progressTypeIcons.consultantRequest}</ListItemIcon>
              <Typography variant="inherit">
                Solicitação Consultoria Transtornos Alimentares
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/encaminhamento-atendimento-pais`)}
            >
              <ListItemIcon>{progressTypeIcons.parents}</ListItemIcon>
              <Typography variant="inherit">
                Encaminhamento Atendimento a Pais
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/encaminhamento-transtornos-alimentares`)}
            >
              <ListItemIcon>{progressTypeIcons.foodForward}</ListItemIcon>
              <Typography variant="inherit">
                Encaminhamento Setor Transtornos Alimentares
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
                history.push(`/prontuarios/${id}/formularios/encaminhamento-setor-grupos`)}
            >
              <ListItemIcon>{progressTypeIcons.groupForward}</ListItemIcon>
              <Typography variant="inherit">
                Encaminhamento Setor de Grupos
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
    history.push(`/prontuarios/${id}/formularios/encaminhamento-psicopedagogia`)}
            >
              <ListItemIcon>{progressTypeIcons.psychopedagogy}</ListItemIcon>
              <Typography variant="inherit">
                Encaminhamento para Psicopedagogia
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
    history.push(`/prontuarios/${id}/formularios/encaminhamento-terapeuta`)}
            >
              <ListItemIcon>{progressTypeIcons.forwarding}</ListItemIcon>
              <Typography variant="inherit">
                Encaminhamento para Terapeuta
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
    history.push(`/prontuarios/${id}/formularios/reducao-valor`)}
            >
              <ListItemIcon>{progressTypeIcons.discount}</ListItemIcon>
              <Typography variant="inherit">
                Pedido Redução do Valor Consulta
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/psicodiagnostico`)}
            >
              <ListItemIcon>{progressTypeIcons.diagnosis}</ListItemIcon>
              <Typography variant="inherit">Psicodiagnóstico</Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/avaliacao-psiquiatrica`)}
            >
              <ListItemIcon>{progressTypeIcons.psychiatric}</ListItemIcon>
              <Typography variant="inherit">Avaliação Psiquiátrica</Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/revisao-semestral-plano`)}
            >
              <ListItemIcon>{progressTypeIcons.quarterplan}</ListItemIcon>
              <Typography variant="inherit">
                Revisão Semestral do Plano de Tratamento
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/evolucao-mensal-ambientoterapia`)}
            >
              <ListItemIcon>{progressTypeIcons.monthlyEvolution}</ListItemIcon>
              <Typography variant="inherit">
                Evolução Mensal do Paciente em Ambientoterapia
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/evolucao-mensal-nutricao`)}
            >
              <ListItemIcon>
                {progressTypeIcons.monthlyNutritionEvolution}
              </ListItemIcon>
              <Typography variant="inherit">
                Evolução Mensal da Nutrição
              </Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/evolucao-psiquiatrica`)}
            >
              <ListItemIcon>
                {progressTypeIcons.psychiatryEvolution}
              </ListItemIcon>
              <Typography variant="inherit">Evolução Psiquiátrica</Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              /* prettier-ignore */
              onClick={() =>
history.push(`/prontuarios/${id}/formularios/encerramento-atendimento`)}
            >
              <ListItemIcon>{progressTypeIcons.closure}</ListItemIcon>
              <Typography variant="inherit">
                Encerramento do Atendimento
              </Typography>
            </MenuItem>
          </Menu>

          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            startIcon={<AddCircle />}
            disabled={
              record?.status !== 'active' ||
              record?.supervisor_id?.includes(keycloak?.subject as string)
            }
            onClick={() => handleOpenProgress()}
          >
            Adicionar Evolução
          </Button>
          {/* TODO: Add reopen record button */}
        </div>
      </Grid>

      <Divider />

      <Grid container className={classes.filter}>
        <Grid item xs={4} style={{ marginBottom: '10px' }}>
          <FormLabel className={classes.formTitles}>Terapeuta</FormLabel>
        </Grid>

        <Grid item xs={4} style={{ marginBottom: '10px' }}>
          <FormLabel className={classes.formTitles}>Setores</FormLabel>
        </Grid>

        <Grid item xs={4} style={{ marginBottom: '10px' }}>
          <FormLabel className={classes.formTitles}>
            Supervisão / Preceptoria
          </FormLabel>
        </Grid>

        <Grid item xs={3}>
          {users.length > 0 &&
            professionalIds.length > 0 &&
            coordIds.length > 0 && (
              <ReactSelect
                closeMenuOnSelect
                isMulti
                placeholder="Selecione"
                isDisabled={
                  record?.status !== 'active' ||
                  record?.supervisor_id?.includes(keycloak?.subject as string)
                }
                options={users.filter((user) =>
                  professionalIds.includes(user.value),
                )}
                defaultValue={users.filter(
                  (user) =>
                    record?.professional_id.includes(user.value) &&
                    professionalIds.includes(user.value),
                )}
                onChange={handleProfessionalSelect}
                menuPosition="fixed"
              />
            )}
        </Grid>

        <Grid item xs={1} />

        <Grid item xs={3}>
          {users.length > 0 &&
            professionalIds.length > 0 &&
            coordIds.length > 0 && (
              <ReactSelect
                closeMenuOnSelect
                isMulti
                placeholder="Selecione"
                isDisabled={
                  record?.status !== 'active' ||
                  record?.supervisor_id?.includes(keycloak?.subject as string)
                }
                options={users.filter((user) => coordIds.includes(user.value))}
                defaultValue={users.filter(
                  (user) =>
                    record?.professional_id.includes(user.value) &&
                    coordIds.includes(user.value),
                )}
                onChange={handleCoordSelect}
                menuPosition="fixed"
              />
            )}
        </Grid>

        <Grid item xs={1} />

        <Grid item xs={3}>
          {users.length > 0 && (
            <ReactSelect
              closeMenuOnSelect
              isMulti
              placeholder="Selecione"
              options={users}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              isDisabled
              onChange={handleSupervisorSelect}
              defaultValue={users.filter((user) =>
                record?.supervisor_id.includes(user.value),
              )}
              menuPosition="fixed"
            />
          )}
        </Grid>
      </Grid>

      <Divider />

      <div className={classes.timelineContainer}>
        <Form ref={formFilterRef} initialData={{}} onSubmit={handleFilters}>
          <Grid container className={classes.filterHeader}>
            <Grid item xs={3}>
              <h3 className={classes.title}>
                {`Evoluções - ${record?.patient?.name || ''} ${
                  (record?.patient2 && ` / ${record?.patient2?.name}`) || ''
                }`}
              </h3>
            </Grid>

            <Grid item xs={1} />

            <Grid item xs={3}>
              <Select
                name="type"
                isMulti={false}
                placeholder="Tipo"
                isClearable
                className={classes.item}
                onChange={(e) => handleFilters('type', e)}
                options={[
                  { value: 'evolution', label: 'Evolução' },
                  { value: 'init', label: 'Ficha inicial' },
                  { value: 'review', label: 'Ficha de Avaliação' },
                  { value: 'forwarding', label: 'Encaminhamento terapeuta' },
                  {
                    value: 'foodForward',
                    label: 'Encaminhamento Transtornos Alimentares',
                  },
                  {
                    value: 'socialService',
                    label: 'Encaminhamento Serviço Social',
                  },
                  {
                    value: 'parents',
                    label: 'Encaminhamento Atendimento a Pais',
                  },
                  {
                    value: 'psychopedagogy',
                    label: 'Encaminhamento Psicopedagogia',
                  },
                  {
                    value: 'groupForward',
                    label: 'Encaminhamento Setor de Grupos',
                  },
                  { value: 'closure', label: 'Encerramento do Atendimento' },
                  { value: 'discount', label: 'Redução do valor' },
                  { value: 'diagnosis', label: 'Psicodiagnóstico' },
                  { value: 'psychiatric', label: 'Avaliação Psiquiátrica' },
                  { value: 'quarterplan', label: 'Plano semestral' },
                  { value: 'screening', label: 'Triagem' },
                  {
                    value: 'monthlyEvolution',
                    label: 'Evolução mensal ambientoterapia',
                  },
                ]}
              />
            </Grid>

            <Grid item xs={3}>
              <Select
                name="professional"
                isMulti={false}
                placeholder="Profissional"
                isClearable
                className={classes.item}
                onChange={(e) => handleFilters('author', e)}
                options={authors}
              />
            </Grid>

            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="Data"
                  inputFormat="dd/MM/yyyy"
                  value={date}
                  className={classes.item}
                  onChange={(d) => {
                    setDate(d);
                    handleFilters('date', d);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Form>

        <Divider />

        <div id="timeline" className={classes.timelineContainer}>
          <Timeline align="left" className={classes.timeline}>
            {!loading && !progress.length && <EmptyProgress />}

            {progress.map((p) => (
              <TimelineItem data-test="true" key={p._id}>
                <TimelineOppositeContent className={classes.opposite}>
                  <Typography variant="body1" color="textSecondary">
                    {moment(p.createdAt).format('DD/MM/YYYY HH:mm')}
                  </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot color="inherit">
                    {progressTypeIcons[p?.type || '']}
                  </TimelineDot>
                  {progress[progress.length - 1]._id !== p._id && (
                    <TimelineConnector />
                  )}
                </TimelineSeparator>
                <TimelineContent className={classes.content}>
                  <Paper
                    elevation={4}
                    className={classes.paper}
                    style={{
                      borderStyle: !p.approved ? 'dotted' : 'none',
                      opacity: !p.approved ? '60%' : '100%',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography variant="h6" component="h1">
                        {`${p.title} ${!p.approved ? '(Rascunho)' : ''}`}
                      </Typography>

                      <div>
                        {(record?.professional_id?.includes(
                          keycloak?.subject as string,
                        ) ||
                          keycloak.realmAccess?.roles.includes(
                            RealmRoles.ADMIN,
                          )) &&
                          !p.approved && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.noteButton}
                              startIcon={<Edit />}
                              onClick={() => handleOpenEditProgress(p)}
                            >
                              Editar
                            </Button>
                          )}

                        {/* TODO: review this */}
                        {(record?.supervisor_id?.includes(
                          keycloak?.subject as string,
                        ) ||
                          record?.professional_id?.includes(
                            keycloak?.subject as string,
                          ) ||
                          keycloak.realmAccess?.roles.includes(
                            RealmRoles.ADMIN,
                          )) &&
                          !p.approved && (
                            <Button
                              variant="contained"
                              color="primary"
                              style={{
                                background: colors.green[700],
                              }}
                              className={classes.noteButton}
                              startIcon={<Check />}
                              onClick={() => handleSubmitApproveProgress(p._id)}
                            >
                              Aprovar
                            </Button>
                          )}

                        {(record?.supervisor_id?.includes(
                          keycloak?.subject as string,
                        ) ||
                          record?.professional_id?.includes(
                            keycloak?.subject as string,
                          ) ||
                          keycloak.realmAccess?.roles.includes(
                            RealmRoles.ADMIN,
                          )) &&
                          !p.approved && (
                            <Button
                              variant="contained"
                              color="primary"
                              style={{
                                background: colors.red[700],
                              }}
                              className={classes.noteButton}
                              startIcon={<Delete />}
                              onClick={() => handleSubmitDeleteProgress(p._id)}
                            >
                              Deletar
                            </Button>
                          )}

                        {record?.supervisor_id?.includes(
                          keycloak?.subject as string,
                        ) && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.noteButton}
                            startIcon={<AddCircle />}
                            onClick={() => handleOpenNote(p)}
                          >
                            Adicionar Nota
                          </Button>
                        )}
                      </div>
                    </div>

                    <Typography>
                      {p.content}

                      <div className={classes.content}>
                        {p.forms.map((form) => (
                          <>
                            <Link
                              style={{ paddingRight: '2%' }}
                              href={`/prontuarios/${record?._id}/formularios/${
                                FormTypeToUrl[form.type]
                              }/${form._id}`}
                              key={form._id}
                            >
                              {`Ver ${TypeToTitle[form.type]}`}
                            </Link>
                          </>
                        ))}
                      </div>

                      <div className={classes.content}>
                        {p.files
                          .filter((file) => file)
                          .map((file) =>
                            getFileChip(
                              file.mimetype,
                              file.originalname,
                              file.path,
                              handleDownload,
                            ),
                          )}
                      </div>

                      <Typography
                        variant="body2"
                        color="textSecondary"
                        align="right"
                      >
                        {`Adicionado por ${p.author} em ${moment(
                          p.createdAt,
                        ).format('DD/MM/YYYY HH:mm')}`}
                      </Typography>
                    </Typography>
                  </Paper>

                  {notes && (
                    <Grid container justify="flex-end">
                      {p.notes.map((note) => (
                        <Grid
                          item
                          style={{
                            display:
                              note.destination_id === keycloak?.subject ||
                              note.author_id === keycloak?.subject
                                ? ''
                                : 'none',
                          }}
                        >
                          <Paper
                            elevation={4}
                            className={classes.notes}
                            style={{
                              borderStyle: !note.saved ? 'dotted' : '',
                              opacity: !note.saved ? '60%' : '100%',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <Typography variant="subtitle1" component="h1">
                                {`${note.title} ${
                                  !note.saved ? '(Rascunho)' : ''
                                }`}
                              </Typography>

                              <div>
                                {record?.supervisor_id?.includes(
                                  keycloak?.subject as string,
                                ) &&
                                  !note.saved && (
                                    <>
                                      <Tooltip title="Editar nota">
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          className={classes.editButton}
                                          startIcon={<Edit />}
                                          /* prettier-ignore */
                                          onClick={() =>
                                            handleOpenEditNote(note)}
                                        />
                                      </Tooltip>

                                      <Tooltip title="Salvar nota">
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          style={{
                                            background: colors.green[700],
                                          }}
                                          className={classes.editButton}
                                          startIcon={<Check />}
                                          /* prettier-ignore */
                                          onClick={() =>
                                      handleSubmitApproveNote(note)}
                                        />
                                      </Tooltip>
                                    </>
                                  )}
                              </div>
                            </div>

                            <Typography variant="subtitle2">
                              {note.content}
                            </Typography>

                            <div className={classes.content}>
                              {note.files.map((file) =>
                                getFileChip(
                                  file.mimetype,
                                  file.originalname,
                                  file.path,
                                  handleDownload,
                                ),
                              )}
                            </div>

                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                              align="right"
                            >
                              {`Adicionado por ${note.author} em ${moment(
                                note.createdAt,
                              ).format('DD/MM HH:mm')}`}
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </div>
        {alert.isActive && <Snackbar {...alert} />}
      </div>
    </div>
  );
};

export default ShowRecord;
